// src/features/dashboard/services/userDashboardService.ts

import {
  memberService,
} from '../../member/services/memberService';

import {
  seedService,
} from '../../seed/services/seedService';

import {
  storeService,
} from '../../store/services/storeService';

import type {
  DashboardUser,
  UserDashboardData,
} from '../types/userDashboard.types';


export const userDashboardService = {
  /**
   * 사용자 대시보드 데이터 조회
   *
   * 내부적으로:
   * - 내 정보
   * - 내 매장별 포인트
   * - 전체 매장 목록
   *
   * 을 조회한 뒤
   * 매장 이름까지 병합합니다.
   */
  async getDashboard():
    Promise<UserDashboardData> {

    const [
      member,
      pointList,
      storeList,
    ] =
      await Promise.all([
        memberService
          .getMyInfo(),

        seedService
          .getMyStorePointList(),

        storeService
          .getStores(),
      ]);


    const safePointList =
      Array.isArray(
        pointList,
      )
        ? pointList
        : [];


    const safeStoreList =
      Array.isArray(
        storeList,
      )
        ? storeList
        : [];


    const storeMap =
      new Map<
        number,
        string
      >(
        safeStoreList.map(
          (
            store,
          ) => [
            store.storeId,
            store.storeName,
          ],
        ),
      );


    const mappedPointList =
      safePointList.map(
        (
          point,
        ) => ({
          ...point,

          storeName:
            storeMap.get(
              point.storeId,
            ) ??
            point.storeName ??
            '',
        }),
      );


    const user:
      DashboardUser = {
        ...member,

        pointList:
          mappedPointList,
      };


    return {
      user,
    };
  },
};